require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/is-iterable.js
// module id = 101
// module chunks = 0